import React, { useEffect, useState } from "react";
import { Button, Input, NavBar } from 'antd-mobile';
import { BodyView, DividerLoginView } from "../factory/ViewUtil";
import { LogoIcon } from "../icons";
import { ToastLoading, ToastContent, ToastClear } from "../factory/FactoryUtil";
import { H5Login, isLogin } from "../../NetworkFactory";

const LoginViewController = ({navpush, goback, gohome}) => {
    const goLogin = ()=> {
        if (username.trim().length < 3 || password.trim().length < 6) {
            ToastContent('Email or password Cannot be empty')
            return
        }

        ToastLoading('Logging...');
        H5Login(username, password).then(code => {
            if(code === 200) {
                ToastContent('Login Success')
                gohome()
            }
            else if(code === -10) {
                ToastContent('You have been banned login')
            }
            else if(code === -1) {
                ToastContent('Email or password error')
            }
            else {
                ToastContent('Login Failed')
            }
        })
    };

    const [username, setUsername] = useState(localStorage.getItem('username') || '') // autors7@gmail.com
    const [password, setPassword] = useState(localStorage.getItem('password') || '') // 123456
    useEffect(() => {
        if(isLogin()) {
            gohome()
        }
        return () => {
            ToastClear()
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return(
        <>
            <div className='fixed-nav-bar'>
                <NavBar onBack={goback}></NavBar>
            </div>
            <BodyView>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '76vh' }}>
                    <div style={{width : '94%', textAlign : 'center'}}>
                        <div style={{margin : '10px 0'}}><LogoIcon /></div>
                        <div style={{fontSize : '18px', fontWeight : 'bold'}}>Crypto Assets</div>
                        <div style={{border : '1.8px #000 solid', borderRadius : '12px', padding : '12px', margin: '12px 0'}}>
                            <Input value={username} onChange={val => {setUsername(val)}} clearable placeholder='Enter your email' style={{marginBottom : '12px'}}/>
                            <Input value={password} onChange={val => {setPassword(val)}} type="password" clearable placeholder='Password'/>
                        </div>
                        <DividerLoginView onClickLeft={goLogin} onClickRight={()=>{navpush('/register')}}/>
                        <Button onClick={()=> {navpush('/forgot')}} color='primary' fill='none' size="small"  style={{marginTop : '10px', color : '#000'}}>Forgot password?</Button>
                    </div>
                </div>
            </BodyView>
        </>
    );
}
export default LoginViewController